/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const downloadFile = (file: any, title: string): void => {
  let data: any = {};

  if (title.endsWith('.pdf')) {
    const decodedData = atob(file);
    const bytes = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
      bytes[i] = decodedData.charCodeAt(i);
    }
    data = bytes.buffer;
  } else {
    data = file;
  }

  const blob = new Blob([data]);
  const newUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = newUrl;
  link.setAttribute('download', title);
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(newUrl);
  link.remove();
};

export const previewFile = (file: any): void => {
  const blob = new Blob([file], { type: 'application/pdf' });
  const newUrl = URL.createObjectURL(blob);

  window.open(newUrl, '_blank');
  URL.revokeObjectURL(newUrl);
};
